import {Card, Box, Typography} from '@material-ui/core';
import {useEffect, useState} from "react";
import {useTranslate} from "react-admin";

import {dashboard} from '../../styles/dashboard';
import axiosForApi from "../../config/axios-for-api";
import CircularProgress from "@material-ui/core/CircularProgress";
import StatHeader from "./StatHeader";

const Loading = () => {
    return (
        <Box display={'flex'} justifyContent={'center'} >
            <CircularProgress size={28.8}/>
        </Box>
    );
}

const StatResult = ({classes, total}: any) => {
    return (
        <Typography className={classes.statsTotal} color="textSecondary">
            {total}
        </Typography>
    );
}

const TotalCustomersWithActivity = ({countries, forCatalogOffers = false}: { countries: string[] | null, forCatalogOffers?:boolean }) => {
    const classes = dashboard();
    const translate = useTranslate();

    const [statsData, setStatsData] = useState({
        total_fmt: ''
    });
    const [shouldLoadStatsData, setShouldLoadStatsData] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        let cancel = false;

        const loadStatsData = async () => {
            const {data} = await axiosForApi.get(`api/admin/${forCatalogOffers?'catalog-offer-stats':'stats'}/total-${forCatalogOffers?'catalog-customers':'customers'}-with-activity`, {
                params: {
                    countries
                }
            });

            if(!cancel) {
                setLoading(false);
                setStatsData(data ?? null);
                setShouldLoadStatsData(false);
            }
        }

        shouldLoadStatsData && loadStatsData();

        return () => {
            cancel = true;
        }
    }, [shouldLoadStatsData, countries, forCatalogOffers]);

    useEffect(() => {
        setLoading(true);
        setShouldLoadStatsData(true);
    }, [countries]);

    return (
        <Card className={classes.card}>
            <Box p={2}>
                <StatHeader
                    title={translate('resources.admin/dashboard.headers.total-customers-with-activity')}
                    help={`resources.admin/dashboard.${forCatalogOffers?'catalog_offers_help':'help'}.total-${forCatalogOffers?'catalog-customers':'customers'}-with-activity`}
                />
                {loading ? <Loading/>: <StatResult classes={classes} total={statsData.total_fmt} />}
            </Box>
        </Card>
    );
}

export default TotalCustomersWithActivity;
